import React, { createContext, useContext, useState } from "react";
import { DeviceLogRepository } from "../../repository/AdminDashboard/DeviceList_Repository";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const StateContext = createContext();
const initialState = {
  DeviceLog: [],
};

// Device log context component
const DeviceLogContext = ({ children }) => {
   // Navigation hook
  const navigate = useNavigate();
  const [DeviceLog, setDeviceLog] = useState(initialState.DeviceLog);
  const [serialnumber, setserialnumber] = useState("");
  const [text, settext] = useState("");
  const [loaded, setloaded] = useState(false);
  const [id, setid] = useState("");
  const [pagenumber, setpagenumber] = useState(1);
  const [countallPge, setcountallPge] = useState(10);

    // Function to fetch device logs
  const getLog = async (id, text, pageNumber) => {
    const data = {
      id: id,
      text: text,
      pagenumber: pageNumber,
    };
    const deviceLog_data = await DeviceLogRepository.getLogDevice(data);


    if (deviceLog_data.code == 1) {
     setDeviceLog(deviceLog_data.deviceLogList);
    setserialnumber(deviceLog_data.SerialNumber);
    setcountallPge(deviceLog_data.CountAllPages);
    } else if (deviceLog_data.code == 0) {
   
      return toast.error(deviceLog_data.message, {
        className: "text-12 text-dark-blue-200",
      });
    }
  };

  const onLog = async (id_data) => {
    setid(id_data);
    await getLog(id_data, text, pagenumber);
    setloaded(true);
  };

  const BtnlogSearch = async (e) => {
    setloaded(false);
    e.preventDefault();
    await getLog(id, text, pagenumber);
    setloaded(true);
  };

  const logtext = (e) => {
    const tex = e.target.value;
    settext(tex);
  };

  const changePage = async ({ selected }) => {
    setloaded(false);
    setpagenumber(selected + 1);
    await getLog(id, text, selected + 1);
    setloaded(true);
  };

  // back change navigate to last page
  const goBack = () => {
    navigate(-1);
  };

  return (
    <StateContext.Provider
      value={{
        DeviceLog,
        onLog,
        BtnlogSearch,
        logtext,
        loaded,
        countallPge,
        pagenumber,
        changePage,
        serialnumber,
        goBack,
      }}>
      {children}
    </StateContext.Provider>
  );
};
function DeviceLogUsecontext() {
  return React.useContext(StateContext);
}
export { DeviceLogUsecontext };
export default DeviceLogContext;
